export const lessonRatingsSelector = (state: any) => state.lessonRatings;
